<div fxLayout="row" class="snack-container">
    <span>{{ data.msg }}</span>

    <div class="icon-container">
        <mat-icon>{{ data.icon }}</mat-icon>
    </div>
</div>
